export default "__VITE_ASSET__blgTs9Sz__"